import { render } from "./ResetPasswordSuccess.vue?vue&type=template&id=3198c915&scoped=true"
import script from "./ResetPasswordSuccess.vue?vue&type=script&lang=js"
export * from "./ResetPasswordSuccess.vue?vue&type=script&lang=js"

import "./reset-password.scss?vue&type=style&index=0&id=3198c915&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3198c915"]])

export default __exports__